
import { defineAsyncComponent, defineComponent } from 'vue'
import KanbanAddTaskForm from '@/components/KanbanAddTaskForm.vue'
import { updateListService, deleteListService } from '@/services/list'
import { indexTasksByListService, moveTaskService } from '@/services/task'
import WorkspaceDropdown from './WorkspaceDropdown.vue'
import WorkspaceList from './WorkspaceList.vue'
import WorkspaceListItem from './WorkspaceListItem.vue'
import { TaskType } from '@/types/entities'

export default defineComponent({
  props: {
    list: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  components: {
    KanbanAddTaskForm,
    WorkspaceDropdown,
    WorkspaceList,
    WorkspaceListItem,
    KanbanTaskCard: defineAsyncComponent(() => import('@/components/KanbanTaskCard.vue'))
  },
  data () {
    return {
      listTasks: [],
      marker: false,
      showListActions: false,
      listOptionItems: [
        {
          value: 'delete list',
          slot: 'delete'
        }
      ]
    }
  },
  provide () {
    return {
      list: this.list,
      indexTasksByList: this.indexTasksByList,
      addTaskToList: this.addTaskToList,
      updateListTask: this.updateListTask
    }
  },
  methods: {
    addTaskToList (task: TaskType) {
      this.listTasks.push(task)
    },
    updateListTask (task: TaskType) {
      const taskIndex = this.listTasks.findIndex((lt: TaskType) => lt._id === task._id)
      if (taskIndex >= 0) this.listTasks[taskIndex] = task
    },
    async indexTasksByList () {
      const res = await indexTasksByListService(this.$route.params.boardId, this.list._id)
      if (!res.error) {
        this.listTasks = res.data
      }
    },
    async handleListNameChange (event: Event) {
      const target = event.target as HTMLInputElement
      const res = await updateListService(this.$route.params.boardId, this.list._id, {
        name: target.value
      })
      if (!res.error) {
        this.$refs.listNameInput.blur()
        this.$store.commit('UPDATE_CURRENTBOARD_LIST', { listId: this.list._id, data: res.data })
        this.$store.commit('UPDATE_WORKSPACE_BOARDS')
      }
    },
    async handleDeleteList () {
      const res = await deleteListService(this.$route.params.boardId, this.list._id)
      if (!res.error) {
        this.showListActions = false
        this.$store.commit('DELETE_CURRENTBOARD_LIST', this.list._id)
        this.$store.commit('UPDATE_WORKSPACE_BOARDS')
      }
    },
    handleDragEnter (e: DragEvent) {
      e.preventDefault()
    },
    handleDragOver (e: DragEvent) {
      e.preventDefault()
    },
    handleDrop (e: DragEvent) {
      e.preventDefault()
      const data = JSON.parse(e.dataTransfer.getData('text/plain'))
      this.moveTaskOnDrop(data)
    },
    handleDragEnd (e: DragEvent) {
      e.preventDefault()
    },
    async moveTaskOnDrop (data: Record<string, string>) {
      const res = await moveTaskService(
        this.$route.params.boardId,
        this.$route.params.boardId,
        data.listId,
        this.list._id,
        data.taskId
      )
      if (!res.error) {
        this.$store.commit('MOVE_CURRENTBOARD_LIST_TASK', {
          fromListId: data.listId,
          toListId: this.list._id,
          taskId: data.taskId
        })
      }
    }
  },
  watch: {
    'list.tasks': {
      handler () {
        this.indexTasksByList()
      },
      immediate: true
    }
  }
})
